(function ($) {
  'use strict';

  /**
   * Main functionality should be in an 'init' function
   */
  var initStickyHeader = function () {
    var self = this;

    var scrollUp = 'scroll-up';
    var scrollDown = 'scroll-down';
    var lastScroll = 0;
    var desktop = window.matchMedia('(min-width: 1024px)');
    var responsive = window.matchMedia('(max-width: 1023px)');

    window.addEventListener('scroll', function (e) {
      var currentScroll = window.pageYOffset;
      if (currentScroll === 0) {
        self.classList.remove(scrollUp);
        $('body').removeClass('scrollUp');
        return;
      }

      if (desktop.matches && currentScroll <= 166 || responsive.matches && currentScroll <= 115) {
        self.classList.remove(scrollDown);
        self.classList.remove(scrollUp);
        $('body').removeClass('scrollUp');
        $('body').removeClass('scrollDown');
      }
      else if (currentScroll > lastScroll && !self.classList.contains(scrollDown)) {
        // down
        self.classList.remove(scrollUp);
        self.classList.add(scrollDown);
        $('body').removeClass('scrollUp');
        $('body').addClass('scrollDown');
      }
      else if (currentScroll < lastScroll && self.classList.contains(scrollDown)) {
        // up
        self.classList.remove(scrollDown);
        self.classList.add(scrollUp);
        $('body').removeClass('scrollDown');
        $('body').addClass('scrollUp');
      }
      lastScroll = currentScroll;
    });
  };

  /**
   * This is boilerplate: add a behavior to window.DP.behaviors
   */
  window.DP.behaviors.stickyHeader = {
    attach: function (context) {
      once('stickyHeader', '.cc--header', context)
        .forEach((e) => {
          initStickyHeader.apply(e);
        });
      // $(context).find('.cc--header').once('stickyHeader').each(function () {
      //   initStickyHeader.apply(this);
      // });
    }
  };

}(jQuery));

